import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { BookCover } from "./BookCover";
import { Input } from "./ui/input";

function ShelfCard({ s }) {
  return (
    <Link to={`/shelves/${s.id}`} className="block group border border-border rounded-md bg-card p-4 paper-shadow hover:border-primary transition-colors" data-testid={`shelf-card-${s.id}`}>
      <div className="flex gap-1.5 h-24 items-end">
        {s.preview.length ? s.preview.map((b) => (
          <div key={b.id} className="w-12"><BookCover book={b} size="sm" /></div>
        )) : <div className="font-reader italic text-sm text-muted-foreground">empty for now</div>}
      </div>
      <div className="mt-3 font-display text-lg group-hover:text-primary transition-colors">{s.name}</div>
      <div className="font-ui text-xs text-muted-foreground">{s.count} {s.count === 1 ? "book" : "books"}</div>
    </Link>
  );
}

export default function ShelvesSection() {
  const [shelves, setShelves] = useState([]);
  const [name, setName] = useState("");

  useEffect(() => { api.get("/shelves").then((r) => setShelves(r.data.shelves)).catch(() => {}); }, []);

  const create = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    try {
      const r = await api.post("/shelves", { name: name.trim() });
      setShelves((v) => [...v, r.data]);
      setName("");
      toast.success("shelf created");
    } catch { toast.error("could not create shelf"); }
  };

  return (
    <section className="mt-20" data-testid="shelves-section">
      <div className="flex items-center justify-between flex-wrap gap-4">
        <h2 className="font-display text-3xl md:text-4xl tracking-tight lowercase">your shelves</h2>
        <form onSubmit={create} className="flex gap-2">
          <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="name a new shelf…" className="rounded-full font-ui w-56" data-testid="shelves-new-input" />
          <button type="submit" data-testid="shelves-create-btn" className="inline-flex items-center gap-1 font-ui text-xs tracking-caps px-4 rounded-full border border-border hover:bg-secondary transition-colors">
            <Plus className="w-3.5 h-3.5" /> create
          </button>
        </form>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-6">
        {shelves.map((s) => <ShelfCard key={s.id} s={s} />)}
      </div>
    </section>
  );
}
